<div class="position-relative">
  <mat-hint align="end" *ngIf="maxlength">{{control?.value?.length || 0}}/{{maxlength}}</mat-hint>
  <textarea class=" form-textarea p-3 " [formControl]="control" [placeholder]="placeholder" matInput [maxlength]="maxlength">
  </textarea>
</div>


